import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Calendar, ShoppingCart, Lightbulb, Gift, Sparkles } from 'lucide-react';
export function ValueStack() {
  const items = [{
    icon: <BookOpen className="w-5 h-5 text-white" data-id="element-290" />,
    title: 'Guía Maestra PDF',
    desc: 'El sistema paso a paso para pasar del pánico a la calma en 5 días.',
    iconBg: 'bg-sage-500',
    number: '01'
  }, {
    icon: <Calendar className="w-5 h-5 text-white" data-id="element-291" />,
    title: 'Planificador Maestro de 30 Días',
    desc: 'Un calendario exacto con 4 semanas de menús rotativos. ¡Cero fatiga de decisión!',
    iconBg: 'bg-azul-polvo-500',
    number: '02'
  }, {
    icon: <ShoppingCart className="w-5 h-5 text-white" data-id="element-292" />,
    title: "Lista de Compras 'Entra y Salte'",
    desc: 'Optimizada para que hagas el súper en 20 minutos y no compres nada que no vayas a usar.',
    iconBg: 'bg-terracota-500',
    number: '03'
  }, {
    icon: <Lightbulb className="w-5 h-5 text-white" data-id="element-293" />,
    title: 'Matriz de Sustitución Inteligente',
    desc: '¿Se acabó el pan? ¿Tu hijo no quiere pollo? Te doy la alternativa instantánea.',
    iconBg: 'bg-verde-manzana-500',
    number: '04'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 16,
      scale: 0.97
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1
    }
  };
  return <section className="py-10 px-4 bg-cream-50" data-id="element-294">
      <div className="max-w-3xl mx-auto" data-id="element-295">
        {/* Hero image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center mb-8" data-id="element-296">
          <div className="w-full max-w-2xl rounded-2xl overflow-hidden shadow-xl border-4 border-white" data-id="element-297">
            <img src="https://cdn.magicpatterns.com/uploads/hwadKoZnoB9yFRnGYL8ABb/9.png" alt="Niños felices comiendo loncheras saludables en la escuela" className="w-full h-auto object-cover" data-id="element-298" />
          </div>
        </motion.div>

        <div className="text-center mb-10" data-id="element-299">
          <h2 className="text-2xl md:text-3xl font-black text-charcoal-900 mb-3" data-id="element-300">
            Todo lo que necesitas para{' '}
            <span className="text-naranja-500" data-id="element-301">Dominar la Rutina Escolar</span>
          </h2>
          <p className="text-base text-charcoal-600 font-medium" data-id="element-302">
            Un paquete digital diseñado para darte resultados desde el día 1.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-40px'
      }} className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-303">
          {items.map((item, idx) => <motion.div key={idx} variants={itemVariants} className="bg-white p-5 rounded-2xl border border-cream-200 shadow-sm flex items-start gap-4 group" data-id="element-304">
              <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center ${item.iconBg} shadow-md group-hover:scale-110 transition-transform duration-300`} data-id="element-305">
                {item.icon}
              </div>
              <div className="min-w-0" data-id="element-306">
                <h3 className="text-sm font-bold text-charcoal-900 leading-snug mb-1" data-id="element-307">
                  {item.title}
                </h3>
                <p className="text-charcoal-600 text-xs leading-relaxed" data-id="element-308">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>

        {/* BONUS — Highlighted */}
        <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        type: 'spring',
        stiffness: 200
      }} className="mt-6 relative" data-id="element-309">
          <div className="absolute -inset-1 bg-gradient-to-r from-naranja-500 via-mostaza-500 to-naranja-500 rounded-2xl opacity-75 blur-sm animate-pulse" data-id="element-310"></div>
          <div className="relative bg-white p-5 rounded-2xl border-2 border-naranja-500 shadow-xl flex items-start gap-4" data-id="element-311">
            <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-naranja-500 to-mostaza-500 flex items-center justify-center shadow-lg" data-id="element-312">
              <Gift className="w-6 h-6 text-white" data-id="element-313" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-314">
              <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-315">
                <h3 className="text-base font-black text-charcoal-900" data-id="element-316">
                  BONUS: Guía de Snacks de 2 Minutos
                </h3>
                <span className="inline-flex items-center gap-1 bg-naranja-500 text-white text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider" data-id="element-317">
                  <Sparkles className="w-3 h-3" data-id="element-318" />
                  Regalo
                </span>
              </div>
              <p className="text-charcoal-700 text-sm leading-relaxed" data-id="element-319">
                Ideas ultra-rápidas para esos días donde el despertador no sonó.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}